import AutoComplete from "base/inputs/AutoComplete";
import Ajax from "base/Ajax";
import { getSearchResults } from "pages/search-page";

export function handleNavSearch() {
    const $wrap = $(".js-nav-search");

    if ($wrap.length === 0) {
        return;
    }

    const $input = $wrap.find(".js-nav-search-input");
    const autocomplete = new AutoComplete($input, {
        updateDebounce: 100,
        async getResults(val) {
            return (await getSearchResults({search: val})).results;
        },
        getTextValue(item) {
            return item.name;
        },
        buildItem: function (item, index) {
            let $reason = null;
            if (item.reason === 'keywords') {
                $reason = ["Matches ", eotwJSXFactory('u', null, [item.context])];
            }

            return (
                eotwJSXFactory('li', {className: this.options.classes.listItem}, [
                    eotwJSXFactory('a', {href: item.url, tabIndex: "-1", id: "autocomplete-" + this.uniqueId + "-item-" + index, role: "option", type: "button", className: this.options.classes.listBtn}, [
                        eotwJSXFactory('strong', null, [item.name]),
                        eotwJSXFactory('p', {className: "small"}, [$reason])
                    ])
                ])
            );
        },
    });

    $wrap.on("click", ".js-clear-search", () => {
        $input.val("").focus();
        autocomplete.close(true);
        return false;
    });

    $input.on("input", () => {
        const value = $input.val();

        $wrap.find(".js-clear-search").toggle(value.length > 0);
    });

    $('body').on('click', '.js-toggle-search', function () {
        $('body').toggleClass('body-search-active');

        if ($('body').is('.body-search-active')) {
            $('.js-search input').focus();
        }
        return false;
    });

}
